import Notifications from './Notifications.vue';

const NotificationStore = {
  state: [], // here the notifications will be added
  settings: {
    overlap: false,
    verticalAlign: 'top',
    horizontalAlign: 'right',
    type: 'info',
    timeout: 5000,
    closeOnClick: true,
    showClose: true
  },
  setOptions(options) {
    this.settings = Object.assign(this.settings, options);
  },
  removeNotification(timestamp) {
    const indexToDelete = this.state.findIndex(n => n.timestamp === timestamp);
    if (indexToDelete !== -1) {
      this.state.splice(indexToDelete, 1);
    }
  },
  addNotification(notification) {
    if (typeof notification === 'string' || notification instanceof String) {
      notification = { message: notification };
    }
    if (notification.successMessage) {
      !notification.timeout ? notification.timeout = 6000 : ''
      !notification.icon ? notification.icon = 'fas fa-check-square' : ''
      !notification.type ? notification.type = 'success' : ''
      notification.message = notification.successMessage
    }
    else if (notification.errorMessage) {
      const timeout = process.env.VUE_APP_ENV_TYPE && process.env.VUE_APP_ENV_TYPE != 'development' ? 20000 : 50000 // longer for dev
      !notification.timeout ? notification.timeout = timeout : ''
      !notification.icon ? notification.icon = 'fas fa-exclamation-triangle' : ''
      !notification.type ? notification.type = 'danger' : ''
      notification.message = notification.errorMessage
    }
    else if (notification.infoMessage) {
      !notification.timeout ? notification.timeout = 10000 : ''
      !notification.icon ? notification.icon = 'fas fa-info-square' : ''
      !notification.type ? notification.type = 'info' : ''
      notification.message = notification.infoMessage
    }

    notification.timestamp = new Date();
    notification.timestamp.setMilliseconds(
      notification.timestamp.getMilliseconds() + this.state.length
    );
    Object.keys(this.settings).forEach(key => {
      //console.log(`addNotification(): !notification.${key}`, !notification.key)
      if (eval(`!notification.${key}`)) {
        eval(`notification.${key} = null`) // we create the attribute
        notification[key] = this.settings[key]
      }
    });
    this.state.push(notification);
  },
  notify(notification) {
    if (Array.isArray(notification)) {
      notification.forEach(notificationInstance => {
        this.addNotification(notificationInstance);
      });
    } else {
      this.addNotification(notification);
    }
  }
};

const NotificationsPlugin = {
  install(Vue, options) {
    let app = new Vue({
      data: {
        notificationStore: NotificationStore
      },
      methods: {
        notify(notification) {
          this.notificationStore.notify(notification);
        }
      }
    });
    Vue.prototype.$notify = app.notify;
    Vue.prototype.$notifications = app.notificationStore;
    Vue.component('Notifications', Notifications);
    if (options) {
      NotificationStore.setOptions(options);
    }
  }
};

export default NotificationsPlugin;
